import {Stack} from '@mui/material';
import React from 'react';
import {Link} from 'react-router-dom';
import Typography from '@mui/material/Typography';
import {IconButton} from '@mui/material';

export default function LinkToReviews({productId}) {
	return (
		<Stack direction="row" alignItems="center" sx={{height: '100%'}}>
			<Link to={`/products/${productId}/reviews`} style={{textDecoration: 'none'}}>
				<IconButton>
					<Typography>التقييمات</Typography>
				</IconButton>
			</Link>
		</Stack>
	);
}
